<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="loading"
        color="secondary"
        class="mx-2"
        v-on="on"
      >
        <v-icon
          left
          small
        >
          mdi-progress-upload
        </v-icon>
        <span class="caption">import file</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="pb-0">
        <v-container class="text-center pb-0">
          <v-row>
            <v-col
              class=""
              cols="12"
            >
              <h1 style="font-weight:300;">
                Start by choosing your importing method.
              </h1>
              <div class="mt-4">
                * The imported file must have the same
                schema/fields as this dataset.
              </div>
              <div class=" mt-4">
                Here's some test data (<a
                  href="https://www.data.gouv.fr/fr/datasets/r/88a27fdd-e328-4a80-8f02-30fcf161f23d"
                >marche.csv</a>) you can download and play around with.
              </div>
            </v-col>
          </v-row>
          <v-row class="px-5">
            <v-row>
              <v-col cols="12">
                <div
                  class="upload_method"
                  :class="{
                    drag_enter: drag_enter
                  }"
                  @dragend="handDragLeaveFileUpload"
                  @dragleave="handDragLeaveFileUpload"
                  @dragenter="handDragEnterFileUpload"
                >
                  <v-icon>mdi-content-save-outline</v-icon>
                  <div class="title">
                    Upload file
                  </div>
                  <div
                    v-if="file && !loading"
                    class="details"
                  >
                    <v-icon class="fs-2 mr-2">
                      mdi-check-circle-outline
                    </v-icon>File selected ({{ file.name }})
                    <br>
                    <v-btn
                      class="mt-2"
                      color="success"
                      small
                      depressed
                    >
                      Choose new file
                    </v-btn>
                  </div>
                  <div
                    v-else-if="loading"
                    class="details"
                  >
                    <div>Getting your file</div>
                    <v-progress-linear
                      style="margin-top: 8px; width: 50%; display: inline-block;"
                      color="success"
                      indeterminate
                      rounded
                      height="6"
                    />
                  </div>
                  <div
                    v-else
                    class="details"
                  >
                    Drag your excel, csv or json file here
                    to begin or click to browse.
                  </div>
                  <input
                    ref="file_upload_input"
                    :disabled="loading"
                    type="file"
                    @change="handleFileUploadChange($event)"
                  >
                </div>
              </v-col>
            </v-row>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="isTruncate"
                :disabled="loading"
                label="Truncate existing data"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col class="text-center pt-0">
              <v-btn

                :loading="loading"
                :disabled="loading || file == null"
                color="primary"
                class="mr-2"
                @click="submit"
              >
                Import
              </v-btn>
              <v-btn

                :disabled="loading"
                text
                @click="dialog = false"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import DatasetService from './services/DatasetService'
  export default {
    name: 'ReimportDatasetBtn',
    props: {
      dataset: {
        type: Object,
        default: () => {
          return {
            hmd_id: null,
          }
        },
      },
    },
    data () {
      return {
        drag_enter: false,
        dialog: false,
        file: null,
        isTruncate: false,
        project: '',
        loading: false,
      }
    },
    mounted () {
      this.project = this.$route.params.project
    },
    methods: {
      clear () {
        this.$refs.file_upload_input.value = ''
        this.isTruncate = false
        this.file = null
        this.loading = false
      },
      handleFileUploadChange (e) {
        this.file = e.target.files[0]
      },
      handDragLeaveFileUpload (e) {},
      handDragEnterFileUpload (e) {},
      submit () {
        const self = this
        this.loading = true
        if (this.isTruncate) {
          this.$store.commit('confirm', {
            message: 'This action is data destructive, are you sure you want to proceed ?',
            title: 'Warning',
            color: 'warning',
            onCancel: () => {
              self.loading = false
              this.isTruncate = false
            },
            onConfirm: () => {
              DatasetService.reimport(self, self.project, self.dataset, self.isTruncate, self.file).then(r => {
              }).finally(() => {
                self.dialog = false
                self.loading = false
                self.$emit('update')
                self.clear()
              })
            },
          })
        } else {
          DatasetService.reimport(self, self.project, self.dataset, self.isTruncate, self.file).then(r => {
          }).finally(() => {
            self.dialog = false
            self.loading = false
            self.$emit('update')
            self.clear()
          })
        }
      },
    },
  }
</script>
